// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QueryParamConverter {
   cleanParamRx: any
   idParamRx: any
   legacyParamRx: any
   maverickParamRx: any
   params: any
   search: any
   constructor(search: any) {
      let regex
      this.isLegacy = this.isLegacy.bind(this)
      this.extractParams = this.extractParams.bind(this)
      this.addCommandParams = this.addCommandParams.bind(this)
      this.getConvertedParams = this.getConvertedParams.bind(this)
      this.convert = this.convert.bind(this)
      this.search = search.replace(/\+/g, ' ') // form encoding
      // example matches: s.q=foobar | s.fvf%5B%5D=IsScholarly,true | s.fvf[]=Discipline,astronomy %26 astrophysics
      this.legacyParamRx = /s\.\w+(%5B%5D|\[\])?=([^&]*)/g
      // example matches: q=foobar | fvf=IsScholarly,true | fvf=Discipline,astronomy %26 astrophysics
      this.maverickParamRx = /\w+=([^&]*)/g
      // removes square brackets
      this.cleanParamRx  = /s\.(\w+)(%5B%5D|\[\])?/
      this.idParamRx     = /id\=([^\&]*)/g
      this.params = {}

      // extract params
      if (this.isLegacy()) {
         regex = this.legacyParamRx
      } else {
         regex = this.maverickParamRx
      }
      if (this.search) {
         this.extractParams(regex)
      }
   }

   isLegacy() {
      return this.legacyParamRx.test(this.search)
   }

   extractParams(regex: any) {
      let matches
      const pairs = this.search.match(regex)
      if (!pairs) { return }
      pairs.forEach((pair: any) => {
         const rawKey = pair.split('=', 1)[0]
         const key    = rawKey.replace(this.cleanParamRx, '$1')
         const value  = decodeURIComponent(pair.substring(rawKey.length+1))
         if (!this.params[key]) { this.params[key] = [] }
         this.params[key].push(encodeURIComponent(value))
      })

      // parse out doc id
      if (matches = this.search.match(this.idParamRx)) {
         this.params.id = [matches[0].split('=')[1]]
      }
   }

   addCommandParams() {
      if (!this.params.cmd) { return }

      this.params.cmd.forEach((cmd: any) => {
         const operation = cmd.substring(0, cmd.indexOf('('))
         let args      = decodeURIComponent(cmd.substring(operation.length+1, cmd.length-1))
         switch (operation) {
            case "addFacetValueFilters":
               // @ts-expect-error TS(2322) FIXME: Type 'string[]' is not assignable to type 'string'... Remove this comment to see the full error message
               args        = args.split(',')
               // @ts-expect-error TS(2339) FIXME: Property 'shift' does not exist on type 'string'.
               var facet       = args.shift()
               // @ts-expect-error TS(2339) FIXME: Property 'join' does not exist on type 'string'.
               var filterValue = args.join(',')
               if (!this.params.fvf) { this.params.fvf = [] }
               return this.params.fvf.push(`${facet},${encodeURIComponent(filterValue.replace(/\:(t|f)$/, ',$1'))}`)
            case "removeFacetValueFilter":
               if (this.params.fvf) {
                  return this.params.fvf = _(this.params.fvf).reject((f: any) => (new RegExp(`^${args}`)).test(decodeURIComponent(f)))
               }
               break
            case "setRangeFilter":
               return this.params.rf = [args]
            case "removeRangeFilter":
               if (this.params.rf) {
                  return this.params.rf = _(this.params.rff).reject((f: any) => (new RegExp(`^${args}`)).test(f))
               }
               break
            case "setHoldingsOnly":
               if (args === 'false') {
                  return this.params.ho = ['f']
               }
               break
            case "setSortByRelevancy":
               if (this.params.sort) { return delete this.params.sort }
               break
            case "setSort":
               return this.params.sort = [args]
            case "setTextQuery":
               return this.params.q = [args]
         }
      })

      return delete this.params.cmd
   }

   getConvertedParams() {
      // clean up
      if (this.params.ff) { delete this.params.ff }
      if (this.params.rff) { delete this.params.rff }
      if (this.params.keep_r) { delete this.params.keep_r }         // obsolete
      if (this.params.spellcheck) { delete this.params.spellcheck }     // obsolete
      if (this.params.fvgf) { delete this.params.fvgf }           // group filters not supported
      if (this.params.ps) { delete this.params.ps }
      if (this.params.role) { delete this.params.role }
      if (this.params.max) { delete this.params.max }            // artifact: s.rec.max
      if (this.params.light) { delete this.params.light }          // enforced by service

      // rewrite old 'limit to library catalog'
      if (this.params.fq) {
         if (_(this.params.fq).any((f: any) => /SourceType.*Library\ Catalog/.test(decodeURIComponent(f)))) {
            if (!this.params.fvf) { this.params.fvf = [] }
            this.params.fvf.push("SourceType,Library Catalog,f")
         }
         // disallow other filter queries
         delete this.params.fq
      }

      // commands
      this.addCommandParams()

      // fix facet parameters (negated filter part)
      if (this.params.fvf) {
         return this.params.fvf = this.params.fvf.map(function(f: any) {
            if (/,(t|f)$/.test(decodeURIComponent(f))) { return f } else { return f + ',f' }
         })
      }
   }

   convert() {
      const parts  = []
      this.getConvertedParams()

      const encodedPipe = encodeURIComponent('|')
      for (var k in this.params) {
         var v = this.params[k]
         if (v.length !== 0) { parts.push(`${k}=${v.join(encodedPipe)}`) }
      }

      return parts.join('&')
   }
}

class UrlRewriter {
   $location: angular.ILocationService
   $window: angular.IWindowService
   location: Location
   $timeout: angular.ITimeoutService
   constructor($window: any, $location: any, $timeout: angular.ITimeoutService, ) {
      this.urlHasHashBang = this.urlHasHashBang.bind(this)
      this.rewrite = this.rewrite.bind(this)
      this.$timeout = $timeout
      this.$window = $window
      this.$location = $location
      this.location = this.$window.location
   }

   urlHasHashBang() {
      return !!this.location.hash.length
   }

   rewriteLegacyUrl(search: any) {
      const legacy = new QueryParamConverter(search)
      return legacy.convert()
   }

   rewrite() {
      if (this.urlHasHashBang()) { return }

      const path = this.location.pathname
      const search = this.rewriteLegacyUrl(this.location.search)
      this.$timeout(() => {
         this.$location.path(path).search(search).replace()
      }, 0)
   }
}

UrlRewriter.$inject = ['$window', '$location', '$timeout']

angular.module('summonApp.urlRewriter')
   .service('urlRewriter', UrlRewriter)
module.exports = QueryParamConverter
